import React from 'react';

import CustomTooltip from '@/components/common-components/CustomTooltip/CustomTooltip';

import { formatNumber } from '../../../../../../utils/global';

const MiniStat = ({ icon, stat, postType }) => {
  if (postType === 'story') {
    return (
      <CustomTooltip title="Metrics unavailable for stories" placement="top">
        <div className="mini-stat">
          <div className="mini-stat__text">--</div>
        </div>
      </CustomTooltip>
    );
  }
  return (
    <div className="mini-stat">
      {icon} {stat ? formatNumber(stat) : '--'}
    </div>
  );
};

export default MiniStat;
